<template>
  <div v-if="plate">
    <template v-if="appQuestion === 'prosperity_life'">
      <div class="d-flex justify-space-between">
        <h1>
          Are you currently or within the last 30 days have you been confined:
        </h1>
        <PlateHealthPriority />
      </div>

      <p class="mt-4">
        To a hospitalized, psychiatric facility, nursing facility, receiving
        hospice home health care, or confined to a wheelchair due to a disease?
      </p>

      <v-radio-group v-model="plate.prosperity.q1" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <h1 class="mt-6">Are you currently:</h1>

      <p class="mt-4">
        Receiving treatment for any type of cancer, awaiting an organ
        transplant, or require assistance with eating, dressing, toileting,
        walking, or bathing?
      </p>

      <v-radio-group v-model="plate.prosperity.q2" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <h1 class="mt-6">
        Within the last 12 months have you been advised by a member of the
        medical profession:
      </h1>

      <p class="mt-4">
        To have a diagnostic test, surgery, home health care or hospitalization
        which has not yet started, been completed or for which results are not
        known?
      </p>

      <v-radio-group v-model="plate.prosperity.q3" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        To have Kidney Dialysis or use oxygen equipment for assistance in
        breathing? (excluding PAP or nebulizer)
      </p>

      <v-radio-group v-model="plate.prosperity.q4" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <h1 class="mt-6">
        Have you EVER been diagnosed or received treatment for:
      </h1>

      <p class="mt-4">
        AIDS, HIV, Alzheimer's disease, dementia, Lou Gehrig's (ALS), Cirrhosis
        of the Liver (Stage C) or more than one occurrence of cancer?
      </p>

      <v-radio-group v-model="plate.prosperity.q5" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>
    </template>
    <template v-else>
      <div class="d-flex justify-space-between">
        <h1>Within the last year have you been:</h1>
        <PlateHealthPriority />
      </div>

      <p class="mt-4">
        Confined to a hospital for a total of 5 days, or been advised to have a
        surgery or hospitalization that is not yet completed?
      </p>

      <v-radio-group
        v-model="plate.liberty.notCompletedHospitalization"
        class="radio-questions"
        row
      >
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Unable to care for yourself, in a nursing home, hospice, long-term care,
        or assisted living facility?
      </p>

      <v-radio-group v-model="plate.liberty.unableToCare" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">Prescribed oxygen tank for a medical condition?</p>

      <v-radio-group
        v-model="plate.liberty.oxygenCondition"
        class="radio-questions"
        row
      >
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <h1 class="mt-6">Have you EVER been diagnosed or treated for:</h1>

      <p class="mt-4">
        Organ transplant, kidney failure, dialysis, MS, ALS, cystic fibrosis, or
        Lou Gehrig's disease
      </p>

      <v-radio-group
        v-model="plate.liberty.organTransplant"
        class="radio-questions"
        row
      >
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        AIDS, ARC, HIV or any other disorder of the immune system?
      </p>

      <v-radio-group v-model="plate.liberty.immuneSystem" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Congestive heart failure, cardiomyopathy, or two or more instances of
        internal cancer?
      </p>

      <v-radio-group v-model="plate.liberty.heartFailure" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Alzheimer's, dementia, or terminal illness (24 months or less to live)?
      </p>

      <v-radio-group v-model="plate.liberty.dementia" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>
    </template>

    <PlateFooter :onBack="onBack" :onSubmit="onSubmit" :isLoading="isLoading" />
  </div>
</template>

<script>
import { format } from 'date-fns';
import { mapGetters } from 'vuex';
import { PlatesSteps } from '@/common/variables';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import PlateHealthPriority from '@/components/lead/plates/PlateHealthPriority';

export default {
  name: 'HealthPlate',
  components: {
    PlateHealthPriority,
    PlateFooter,
  },
  props: {
    lead: Object,
  },
  computed: {
    ...mapGetters({
      isDisabledBranch: 'plates/branch',
      appQuestion: 'plates/appQuestion',
    }),
    nextPlate() {
      return this.isDisabledBranch
        ? PlatesSteps.disabledHealthFirst
        : PlatesSteps.generalHealth;
    },
  },
  data: () => ({
    plate: null,
    isLoading: false,
    currentLead: {},
  }),
  mounted() {
    this.currentLead = { ...this.lead };
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.health
    );
    this.plate = data;
  },
  methods: {
    format,
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.basicInfo);
    },
    onSubmit() {
      if (this.appQuestion === 'prosperity_life') {
        if (Object.values(this.plate.prosperity).find(Boolean)) {
          this.$store.commit('plates/setAppRate', 'gi');
        }
      } else {
        if (Object.values(this.plate.liberty).find(Boolean)) {
          this.$store.commit('plates/setAppRate', 'gi');
        }
      }

      this.$store.commit('plates/setStep', this.nextPlate);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
};
</script>

<style>
.params-list .v-input--checkbox {
  margin-top: 3px;
}
</style>